var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M 18 3 L 4.5 13.5 L 4.5 30 C 4.5 31.6568489074707 5.8431396484375 33 7.5 33 L 28.5 33 C 30.1568489074707 33 31.5 31.6568489074707 31.5 30 L 31.5 13.5 L 18 3 M 18 -3.814697265625e-06 C 18.65007781982422 -3.814697265625e-06 19.30015563964844 0.2106437683105469 19.84181976318359 0.6319389343261719 L 33.34181976318359 11.1319408416748 C 34.07257843017578 11.70030975341797 34.5 12.5742301940918 34.5 13.5 L 34.5 30 C 34.5 33.30841064453125 31.80841064453125 36 28.5 36 L 7.5 36 C 4.19158935546875 36 1.5 33.30841064453125 1.5 30 L 1.5 13.5 C 1.5 12.5742301940918 1.927421569824219 11.70030975341797 2.658180236816406 11.1319408416748 L 16.15818023681641 0.6319389343261719 C 16.69984436035156 0.2106437683105469 17.34992218017578 -3.814697265625e-06 18 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#002395",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M13.5,33V18h9V33",
    fill: "none",
    stroke: "#002395",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon);
export default __webpack_public_path__ + "static/media/main-icon.0302b414b7a54eb3b1b124dd7891a48c.svg";
export { ForwardRef as ReactComponent };